export default __webpack_public_path__ + "static/media/play_store.b4fd80cd.png";